/*
Copyright (c) 2021 by Roman Prokofyev (https://codepen.io/rprokofyev/pen/jOLGXPr)
Fork of an original work CSS Sunset Sunrise (https://codepen.io/msaetre/pen/nlsJL

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
documentation files (the "Software"), to deal in the Software without restriction,
including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense,
and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import {gsap} from "gsap/gsap-core";

import {getRandomInt} from "../util/color";

let myWidth = 0, myHeight = 0;

export function updateSunrise(brightness, is_sunrise) {
    updateDimensions();
    // function: (x-w/2)²/(w/2)² + y²/h² = 1
    let b = myHeight;
    let trans_y = myHeight;
    let y = -brightness * b;
    y = Math.round(y + trans_y);

    document.getElementById("darknessOverlaySky").style.opacity = Math.min((y - (myHeight * 7 / 10)) / (myHeight * 3 / 10), 1);
    document.getElementById("horizonNight").style.opacity = (y - (myHeight * 8 / 10)) / (myHeight * 2 / 10);
    document.getElementById("sky").style.opacity = 1;


    if (y >= 0) {
        if (y > myHeight / 2) {
            document.getElementById("horizon").style.opacity = (myHeight - y) / (myHeight / 2) + 0.2;
        } else {
            document.getElementById("horizon").style.opacity = Math.min(y / (myHeight / 2), 0.99);
        }

    }


}


function updateDimensions() {
    myWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    myHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

}


document.addEventListener("DOMContentLoaded", function () {
    const stars = document.querySelectorAll('.stars .star, .stars #star-fall');

    function randomPosition() {
        return `${Math.random() * 90 + 5}%`;
    }

    stars.forEach(star => {
        const top = randomPosition();
        const left = randomPosition();

        star.style.top = top;
        star.style.left = left;
    });

    const starFall = document.getElementById("star-fall");

    // Create a pseudo-element and append it to the starFall element
    const pseudoElement = document.createElement("div");
    pseudoElement.style.width = "200px";
    pseudoElement.style.height = "3px";
    pseudoElement.style.background = "linear-gradient(to left, hsla(0 0% 0% / 0) 0%, hsla(0 80% 100% / 0.4) 100%)";
    starFall.appendChild(pseudoElement);

    // GSAP animation
    const timeline = gsap.timeline({
        repeat: -1, // Infinite loop
        repeatDelay: Math.random() * 10 + 3,
        onRepeat: () => {
            starFall.style.top = randomPosition();
            starFall.style.left = randomPosition();
            pseudoElement.style.background = `linear-gradient(to left, hsla(0 0% 0% / 0) 0%, hsla(${getRandomInt(0, 359)} 80% ${getRandomInt(70, 100)}% / 0.4) 100%)`;
        },
    });

    // Add movement animation to the timeline
    timeline.fromTo(
        pseudoElement,
        {
            x: "200px",
        },
        {
            x: "0",
            width: 0,
            duration: 0.8,
            ease: "none",
        }
    );
});